import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { forwardRef, useState } from 'react';
import { CheckboxWrapper, Input, Label, Square, Content } from './style.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import Icon from '../Icon/Icon.js';
import { USER_INTERFACE_TICK_DONE } from '../IconPath/USER_INTERFACE_TICK_DONE.js';

var _excluded = ["checked", "children", "className", "disabled", "onChange", "uniqueId", "fullWidthLabel", "theme", "style"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Checkbox = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var checked = _ref.checked,
    children = _ref.children,
    className = _ref.className,
    disabled = _ref.disabled,
    onChange = _ref.onChange,
    uniqueId = _ref.uniqueId,
    fullWidthLabel = _ref.fullWidthLabel,
    theme = _ref.theme,
    style = _ref.style,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFocused = _useState2[0],
    setIsFocused = _useState2[1];
  if (typeof onChange !== 'function') {
    return false;
  }
  var PotentialLabelContent = children && /*#__PURE__*/jsx(Content, {
    children: children
  });
  return /*#__PURE__*/jsxs(CheckboxWrapper, {
    className: className,
    focused: isFocused,
    style: style,
    children: [/*#__PURE__*/jsx(Input, _objectSpread({
      id: uniqueId,
      type: "checkbox",
      disabled: disabled,
      onChange: onChange,
      onFocus: function onFocus() {
        return setIsFocused(true);
      },
      onBlur: function onBlur() {
        return setIsFocused(false);
      },
      checked: checked,
      ref: ref
    }, rest)), /*#__PURE__*/jsxs(Label, {
      htmlFor: uniqueId,
      fullWidthLabel: fullWidthLabel,
      disabled: disabled,
      children: [checked && /*#__PURE__*/jsx(Icon, {
        path: USER_INTERFACE_TICK_DONE,
        className: "sg-checkbox-icon"
      }), /*#__PURE__*/jsx(Square, {
        disabled: disabled,
        checked: checked,
        theme: theme
      }), PotentialLabelContent]
    })]
  });
});
Checkbox.displayName = 'Checkbox';
Checkbox.defaultProps = {
  checked: false,
  className: null,
  disabled: null,
  children: null,
  uniqueId: null,
  fullWidthLabel: false,
  theme: 'default',
  style: null
};
var Checkbox$1 = Checkbox;

export { Checkbox$1 as default };
//# sourceMappingURL=Checkbox.js.map
